import { memo } from "react";
import type { DocuparserDocument } from "../../../services/docuparserApi";
import { formatDate } from "../../../utils";
import { getStatusClassKey, STATUS_CLASSNAME } from "../../../constants";
import styles from "./DocumentListView.module.css";

interface DocumentCardProps {
  readonly document: DocuparserDocument;
  readonly onOpen: (docId: number) => void;
}

function DocumentCardImpl({ document, onOpen }: DocumentCardProps) {
  const statusClass = styles[STATUS_CLASSNAME[getStatusClassKey(document.status)]];

  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <span className={styles.label}>Name</span>
        <button
          type="button"
          className={styles.docLink}
          title={document.name}
          onClick={() => onOpen(document.id)}
          aria-label={`View document: ${document.name}`}
        >
          {document.name}
        </button>
      </div>

      <div className={styles.row}>
        <span className={styles.label}>Upload</span>
        <div className={styles.uploadDetails}>
          <div className={styles.uploadBy} title={document.createdBy}>
            {document.createdBy}
          </div>
          <div className={styles.uploadDate}>on {formatDate(document.createdAt)}</div>
        </div>
      </div>

      <div className={styles.row}>
        <span className={styles.label}>Status</span>
        <span className={`${styles.statusBadge} ${statusClass ?? ""}`} aria-label={`Status: ${document.status}`}>
          {document.status}
        </span>
      </div>
    </div>
  );
}

export const DocumentCard = memo(DocumentCardImpl);
